import { Outlet, useNavigate, useParams } from "react-router-dom";

import { SectionMenu } from "~/common/components";
import { ConsultationHeader } from "~/providers/components";
import { useCurrentTeamMemberContext, useGetPatient } from "~/providers/hooks";
import { getConsultationMenuOptions } from "~/providers/utils";

export const ConsultationLayout = () => {
  const navigate = useNavigate();

  const { patientId } = useParams();

  const { data: patient } = useGetPatient(patientId);
  const teamMember = useCurrentTeamMemberContext();
  const zoomFeatureEnabled =
    teamMember.organization_team_members[0].organization.settings?.[0]
      ?.zoom_feature;

  if (!patientId || !patient) return null;

  const menuOptions = getConsultationMenuOptions(
    navigate,
    patientId,
    patient.organization_patients[0].status,
    patient.consultation?.has_intake_summary,
    zoomFeatureEnabled,
  );

  return (
    <div className="px-7 text-sm md:px-14">
      <div className="sticky top-0 z-20 flex w-full flex-col bg-white pt-5">
        <ConsultationHeader patient={patient} />

        <div className="flex gap-2 pt-6">
          <SectionMenu menuOptions={menuOptions} />
        </div>
      </div>

      <div className="pb-3 pt-5">
        <Outlet />
      </div>
    </div>
  );
};
